// =============================================================
//  src/supabaseClient.js
//  Asenda SINU_SUPABASE_URL ja SINU_ANON_KEY oma väärtustega
//  Leiad need: Supabase → Project Settings → API
// =============================================================

import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL  = 'https://yzviolggjwcceldgquox.supabase.co'   // nt. https://xyzxyz.supabase.co
const SUPABASE_ANON = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inl6dmlvbGdnandjY2VsZGdxdW94Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzMzMTQwMDgsImV4cCI6MjA4ODg5MDAwOH0.SX5OFCTkx5fdMZqVd4OuHkI5vXN2mk6FSk8DZ3ABo8g'        // public anon key

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON)
